import { useRouteLoaderData } from 'react-router'

import { ConsumerLandingPage } from '~/portal/types/consumer'
import { ConsumerLoaderData } from '~/portal/types/portal'

export const useLandingPage = (): ConsumerLandingPage => {
  const loaderData = useRouteLoaderData<ConsumerLoaderData>('routes/_docs/_index')
  const { landingPageData } = loaderData || {}

  return landingPageData || {}
}